import { useInView } from 'react-intersection-observer';
import { useContext } from 'react';

import FooterCmp from '#src/components/Footer';
import { mergeStyles } from '#src/hooks/use-merged-styles.js';

import { StickyComponentContext } from './StickyComponent/StickyComponentContext.js';
import localStyles from './Footer.scss';

export function Footer({ styles: stylesProp, ...props }) {
  const { setFooterVisible } = useContext(StickyComponentContext);
  const { ref } = useInView({
    rootMargin: '400px',
    onChange: setFooterVisible,
  });

  const styles = mergeStyles(localStyles, stylesProp);
  return (
    <div ref={ref}>
      <FooterCmp {...props} className={styles.container} styles={styles} />
    </div>
  );
}
